/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

// MUIs Cache für Emotion überschreiben
// Siehe: https://mui.com/material-ui/guides/interoperability/#css-injection-order
const cache = createCache({
    key: "lan",
    prepend: true,
});

// Fehlermeldugen aufgrund der Verwendung von CSS-Selektoren wie `:first-child` deaktivieren
// Siehe: https://github.com/emotion-js/emotion/issues/1105#issuecomment-1058225197
cache.compat = true;

type EmotionCacheProviderProps = {
    children?: React.ReactNode;
}

export default function EmotionCacheProvider(props: EmotionCacheProviderProps) {
    return (
        <CacheProvider value={cache}>
            {/* Ab hier können Mui-Themes erstellt werden! */}
            {props.children}
        </CacheProvider>
    );
}
